import { render, staticRenderFns } from "./TransationsAlertPage.vue?vue&type=template&id=4a18b766&scoped=true&"
import script from "./TransationsAlertPage.vue?vue&type=script&lang=ts&"
export * from "./TransationsAlertPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a18b766",
  null
  
)

export default component.exports